// Global Variable

var masterpromorunThemeATC = false;
var masterpromorunNow = false;
var cartloadupt = false;
var masterPromoRunning = false; // Flag to prevent multiple masterPromo executions
var masterPromoTimeout = null; // Store timeout reference for debouncing

var swiperInstances = {};

$(function() {
    masterPromo(false);
    cartJSEvent();
    initMySwiper();
    initCollectionList();
    initGalleyThumbnails();
    onLoadCookieBar();
    initDate();
    enableAccountUpdateWhenFoundChanges();
    getTaxAttr();
    openChatFromPageFly();
    removeOneCardError();
    if (getQueryParam('login-drawer') !== null) {
        openRegisterLoginDrawer();
        openLoginDrawer();
    }
    if (getQueryParam('register-drawer') !== null) {
        openRegisterLoginDrawer();
        openRegisterDrawer();
    }
    if ($(window).width() > 719) {
        setHeight('.complete-the-look__secondary-content', '.complete-the-look__image-container .image .image__img');
    }
})
setHeight = (reference, target) => {
    var referenceHeight = $(reference).height();
    $(target).height(referenceHeight);
}
mobileHeaderMenu = (e) => {
    var open = $(e).attr('aria-expanded');
    // console.log('header menu');
    if (open === 'false') {
        $('.announcement-bar').addClass('d-none');
        $('#drawer-menu__announcement').removeClass('d-none');
        $('.header__row-mobile .header__icon-touch--livechat').addClass('d-none');
        $('.header__row-mobile .header__icon-touch--search').addClass('d-none');
        $('.header__row-mobile .header__icon-touch--quickcart').addClass('d-none');
    } else {
        $('.announcement-bar').removeClass('d-none');
        $('#drawer-menu__announcement').addClass('d-none');
        $('.header__row-mobile .header__icon-touch--livechat').removeClass('d-none');
        $('.header__row-mobile .header__icon-touch--search').removeClass('d-none');
        $('.header__row-mobile .header__icon-touch--quickcart').removeClass('d-none');
    }
}
updatePageNumber = (swiper) => {
    if (!swiper) return;
    const pageNumberDisplay = $(swiper.el).find('.progress-number.start');
    const currentSlide = swiper.activeIndex + 1;
    if (currentSlide > 0 && currentSlide <= 9) {
        pageNumberDisplay.text(`0${currentSlide}`);
    } else {
        pageNumberDisplay.text(currentSlide);
    }
}

initMySwiper = () => {
    $('.swiper.mySwiper').each(function(index, element) {
        var _this = $(element);
        var autoplay = _this.data('autoplay');
        var autoplaySpeed = _this.data('autoplay-speed');
        _this.attr('data-swiper-index', index);

        var swiper_option = {
            pagination: {
                el: ".swiper-pagination",
                type: 'progressbar',
            },
            on: {
                slideChange: function () {
                    updatePageNumber(this);
                },
                init: function () {
                    updatePageNumber(this);
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            slidesPerView: 'auto',
            initialSlide : 0
        }

        if (autoplay && autoplaySpeed != '') {
            swiper_option['autoplay'] = {
                delay: autoplaySpeed,
                disableOnInteraction: false
            }
        }
        var swiper = new Swiper(this, swiper_option);
        swiperInstances[index] = swiper;
    });
}

swiperWrapperContent = (swiper, currentVariant, isThumbnail) => {
    var mediaContent = '';

    if ($('#all-product-media').length) {
        mediaContent = $('#all-product-media');
    } else if ($('#cloneWrapper').length) {
        mediaContent = $('#cloneWrapper');
    }

    var swiperWrapper = $(swiper.el).find('.swiper-wrapper');
    var totalPage = 0;

    if (mediaContent && mediaContent.length) {
        mediaContent.children().each(function() {
            var img = $(this).find('img');
            if (img.attr('alt') === `#color_${currentVariant}`) {
                totalPage += 1
                var cloneSlide = $(this).clone();
                if (isThumbnail) {
                    cloneSlide.removeClass('product__media-item');
                    cloneSlide.addClass('product-thumbnails__item');
                    cloneSlide.children().first().addClass('product-thumbnails__item-image');
                    cloneSlide.children().first().removeClass('media--has-lightbox');
                    cloneSlide.children().first().find('a').removeAttr('href');
                }

                if (totalPage == 1) {
                    swiperWrapper.empty();
                }
                swiperWrapper.append(cloneSlide);
            }
        });

        if (totalPage > 0 ){
            const totalPageDisplay = $(swiper.el).find('.progress-number.end');
            if (totalPageDisplay && totalPage) {
                var formattedPageNumber = totalPage > 0 && totalPage <= 9 ? `0${totalPage}` : `${totalPage}`;
                totalPageDisplay.text(formattedPageNumber);
            }
            swiper.update();
            swiper.slideTo(0);
        }
    }
}

initCollectionList = () => {
    var swiper = new Swiper(".collection-list-slider__content", {
        mousewheel: true,
        pagination: {
            el: ".full-swiper-pagination",
            type: "progressbar",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        spaceBetween: 10,
        slidesPerView: 2,
        breakpoints: {
            // when window width is >= 480px
            480: {
                slidesPerView: 3,
                spaceBetween: 15
            },
            // when window width is >= 640px
            768: {
                slidesPerView: 3,
                spaceBetween: 15
            },
            // when window width is >= 960px
            768: {
                slidesPerView: 4,
                spaceBetween: 20
            }
        }
    });
}

initGalleyThumbnails = () => {
    var swiper_thumbnail = new Swiper(".swiper-thumbnail", {
        spaceBetween: 10,
        slidesPerView: 'auto',
        initialSlide : 0,
        freeMode: true,
        watchSlidesProgress: true,
    });
    var swiper_main = new Swiper(".swiper-main", {
        spaceBetween: 10,
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
        slidesPerView: 'auto',
        initialSlide : 0,
        thumbs: {
            swiper: swiper_thumbnail,
        },
        on: {
            slideChange: function () {
                updatePageNumber(this);
            },
            init: function () {
                updatePageNumber(this);
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    });
    swiperInstances.main = swiper_main;
    swiperInstances.thumbnail = swiper_thumbnail;
}

imageWithTextSplitTextContainer = (e, next) => {
    var _this = $(e);
    var page = _this.siblings('.swiper-wrapper').find('.swiper-slide-active').attr('aria-label');
    var index = page.toString();
    var index_number = parseInt(index.charAt(0));
    var active = 1;
    if (next) {
        active = index_number + 1;
    } else {
        active = index_number - 1;
    }

    $("[class^='iwts__text-container-']").each(function() {
        var className = $(this).attr('class');
        var isActive = className.includes(active);

        if (isActive) {
            $(this).css('display', 'block');
        } else {
            $(this).css('display', 'none');
        }
    });
}

/* start: cookies popup */
//Cookies settings
setCookies = (cname,cval,days) =>{
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));

    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cval + ";" + expires + ";path=/";
}

getCookies = (cname) =>{
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

acceptCookies = (e) =>{
    var $this = $(e);

    $this.parents('.jsc-cookies-container').hide();

    setCookies('jsc-accept-cookie', true, 120);
}

onLoadCookieBar = () =>{
    var isAccpet = getCookies('jsc-accept-cookie') === 'true';
    if (isAccpet) {
        $('.jsc-cookies-container').hide();
    }
}
/* end: cookies popup */

// Start - CartJS Function
cartJSEvent = () => {
    $(document).on('cart.requestStarted', function (event, cart) {
        var $loader = $('.jsc-loader-overlay');
        masterpromorun = true;
        masterpromorunNow = true;
        $loader.show();
    });
    $(document).on('cart.requestComplete', function (event, cart) {
        masterpromorun = false;
        var $loader = $('.jsc-loader-overlay');
        $loader.hide();

        var customEvent = new CustomEvent('apps:product-added-to-cart');
        document.dispatchEvent(customEvent);
        if (location.href.includes('/cart')) {
            location.reload();
        }
        masterpromorunThemeATC = false;
        masterpromorunNow = false;
        
        // Debounce masterPromo calls to prevent multiple triggers
        if (masterPromoTimeout) {
            clearTimeout(masterPromoTimeout);
        }
        masterPromoTimeout = setTimeout(() => {
            // Only call masterPromo if not already running
            if (!masterPromoRunning) {
                masterPromo(false);
            }
            masterPromoTimeout = null;
        }, 1000);
    });
}

cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback

    CartJS.addItem(vid, qty, obj,
        {
            // Define a success callback to display a success message.
            "success": function (data, textStatus, jqXHR) {
                console.log('success');
                $.ajax({
                    url: '/cart.js',
                    dataType: "json",
                    cache: false,
                    beforeSend: function () {
                        console.log('before');
                    },
                    success: function (cart) {
                        console.log('success', location.pathname);
                    }
                });
            },
            // Define an error callback to display an error message.
            "error": function (jqXHR, textStatus, errorThrown) {
                console.log("Error occur !", errorThrown);
            }
        });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback

    CartJS.updateItemById(vid, qty, obj,
        {
            // Define a success callback to display a success message.
            "success": function (data, textStatus, jqXHR) {
                console.log('success');
                $.ajax({
                    url: '/cart.js',
                    dataType: "json",
                    cache: false,
                    beforeSend: function () {
                        console.log('before');
                    },
                    success: function (cart) {
                        console.log('success', location.pathname);
                    }
                });
            },
            // Define an error callback to display an error message.
            "error": function (jqXHR, textStatus, errorThrown) {
                console.log("Error occur !", errorThrown, jqXHR, textStatus);
            }
        });
}
// End - CartJS Function
//Start - onload and onclick all promo
masterPromo = (isDrawer) => {
    // Prevent multiple simultaneous executions
    if (masterPromoRunning) {
        console.log('masterPromo already running, skipping...');
        return;
    }
    
    masterPromoRunning = true;
    console.log('masterpromoRun');
    
    // Use Promise.resolve to ensure sequential execution and proper flag reset
    Promise.resolve()
        .then(() => gwpTierFunction(isDrawer))
        .then(() => cartGift())
        .then(() => gwpFunction(isDrawer))
        .then(() => {
            pwpSetValidationCart();
            updateTolimitbundle();
            tierFunction(isDrawer);
            cartGiftProperties();
        })
        .finally(() => {
            // Reset the flag after a delay to allow cart operations to complete
            setTimeout(() => {
                masterPromoRunning = false;
                console.log('masterPromo completed, flag reset');
            }, 2000);
        });
}
//End - onload and onclick all promo
//Start - Gift properties apps
cartGiftProperties = () => {
    $('.jsc-update-gwp-apps').each(function () {
        var $key = parseInt($(this).val());
        var $qty = parseInt($(this).attr('data-qty'));
        var $gwpcart_product = {};
        $gwpcart_product['_Cart_GWP'] = 'Free Gift';
        cartJSUpdateQuery($key, $qty, $gwpcart_product);
    });
}
//End - Gift properties apps
//Start GWP Tier promo
gwpTierFunction = async (isOpenDrawer) => {
    var $ele = $('._cartGwp');
    if ($ele.length > 0) {
        console.log('adding gwp tier...');
        var $loader = $('.jsc-loader-overlay');

        const cart = await new Promise((resolve, reject) => {
            jQuery.getJSON('/cart.js', function(cartData) {
                resolve(cartData); // Resolve with the data
            }).fail(function(error) {
                reject(error); // Reject if there's an error
            });
        });

        $ele.each(function () {
            $loader.show();
            var $gwpcart_product = {};
            var $vid = parseInt($(this).attr('data-vid'));
            var $tierNo = $(this).attr('data-tier');
            var $tierCol = $(this).attr('data-col');
            $gwpcart_product['GWP Tier ' + $tierNo] = true;
            $gwpcart_product['_Cart_GWP'] = 'Free Gift';
            if ($tierCol) {
                $gwpcart_product['_GWP_col'] = $tierCol;
            }

            var $updateKey = '';
            const items = cart.items;

            // Check item is already in the cart
            for (let index = 0; index < items.length; index++) {
                let item = items[index];
                // console.log('item', item);
                if (item.id == $vid && item.properties[`GWP Tier ${$tierNo}`]) {
                    $updateKey = item.key;
                    break;
                }
            }

            if ($updateKey != '') {
                console.log('change to updating gwp tier...');
                cartJSUpdateQuery($updateKey, 1, $gwpcart_product, isOpenDrawer);
            } else {
                cartJSAddQuery($vid, 1, $gwpcart_product, isOpenDrawer);
            }
        });
    }
}
//End GWP promo
//Start GWP promo
gwpFunction = (isOpenDrawer) => {
    $.when($.getJSON('/cart.js', function (cart) {

    })).then(function (cart) {
        var $loader = $('.jsc-loader-overlay');
        var $gwpcart_product = {};
        var $addEle = $('.jsc-add-gwp');
        var $updateEle = $('.jsc-update-gwp');
        var $deleteEle = $('.jsc-remove-gwp');

        $gwpcart_product['_Promo'] = 'Free Gift';

        $addEle.each(function () {
            $loader.show();
            var $vid = parseInt($(this).val());
            var $qty = parseInt($(this).attr('data-qty'));

            $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

            console.log('test');

            cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
        });

        $updateEle.each(function () {
            $loader.show();
            var $vid = $(this).val();
            var $qty = parseInt($(this).attr('data-qty'));

            $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

            cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
        });

        $deleteEle.each(function () {
            $loader.show();
            var $vid = $(this).val();
            var $qty = 0;

            cartJSUpdateQuery($vid, $qty, {}, isOpenDrawer);
        });

    });
}
//End GWP promo
//Start GWP based on cart, product or collection promo
cartGift = () => {
    addCartGift();
    removeCartGift();
}

addCartGift = async () => {
    var $loader = $('.jsc-loader-overlay');
    var $elem = $('.jsc-cart-gift');
    if ($elem.length > 0) {
        const cart = await new Promise((resolve, reject) => {
          jQuery.getJSON('/cart.js', function(cartData) {
              resolve(cartData); // Resolve with the data
          }).fail(function(error) {
              reject(error); // Reject if there's an error
          });
        });
        console.log('adding cart gift...');
        $elem.each(function () {
            $loader.show();
            var $vid = parseInt($(this).val());
            var $obj = {};
            var $promoNo = $(this).attr('data-promo');
            var $giftqty = parseInt($(this).attr('data-gift-qty'));

            $obj['_Cart_Gift'] = $promoNo;
            $obj['_Cart_GWP'] = 'Free Gift';

            var $updateKey = '';
            const items = cart.items;

            // Check item is already in the cart
            for (let index = 0; index < items.length; index++) {
                let item = items[index];
                if (item.id == $vid && item.properties._Cart_Gift == $promoNo) {
                    $updateKey = item.key;
                    break;
                }
            }

            if ($updateKey != '') {
                console.log('change to updating cart gift...');
                cartJSUpdateQuery($updateKey, $giftqty, $obj, true);
            } else {
                cartJSAddQuery($vid, $giftqty, $obj, true);
            }
        });
    }
    if ($('.jsc-cart-gift-upt').length > 0) {
        console.log('updating cart gift...');
        $('.jsc-cart-gift-upt').each(function () {
            $loader.show();
            var $vid = $(this).val();
            var $qty = parseInt($(this).attr('data-qty'));

            var $obj = {};
            var $promoNo = $(this).attr('data-promo');
            $obj['_Cart_Gift'] = $promoNo;
            $obj['_Cart_GWP'] = 'Free Gift';

            cartJSUpdateQuery($vid, $qty, $obj, false);
        });
    }
}

removeCartGift = () => {
    var $loader = $('.jsc-loader-overlay');
    var $elem = $('.jsc-cart-gift-remove');
    if ($elem.length > 0) {
        console.log('removing cart gift...');
        $elem.each(function () {
            $loader.show();
            var $key = parseInt($(this).val());

            if ($elem.length > 0) {
                cartJSUpdateQuery($key, 0, {}, true);
            }
        });
    }
}
//End GWP based on cart, product or collection promo
//Start tier discount promo
tierFunction = (isOpenDrawer) => {
    var $updateEle = $('.jsc-tier-product');
    var $removeEle = $('.jsc-tier-product-remove');

    $updateEle.each(function () {
        var $obj = {};
        var $this = $(this);
        var $key = $this.attr('data-key');
        var $discountVal = $this.val();
        var $discountType = $this.attr('data-discount-type');
        var $tierNo = $this.attr('data-promo-no');
        var $qty = parseInt($this.attr('data-qty'));

        $obj['_Promo-no'] = $tierNo;
        $obj['_Tier'] = true;

        cartJSUpdateQuery($key, $qty, $obj, isOpenDrawer);
    });

    $removeEle.each(function () {
        var $this = $(this);
        var $key = $this.val();
        var $promoNo = $this.attr('data-promo-no');
        $.when($.getJSON('/cart.js')).then(function (cart) {
            var $items = cart.items;
            for (var i = 0; i < $items.length; i++) {
                var $thisKey = $items[i].key;
                var $thisQty = $items[i].quantity;
                var $thisProps = $items[i].properties;
                var $vID = parseInt($items[i].variant_id);

                if ($thisKey == $key && $thisProps['_Promo-no'] == $promoNo) {
                    delete $thisProps['_Quantity-Promo'];
                    delete $thisProps['_Off-Value'];
                    delete $thisProps['_Promo-no'];
                    delete $thisProps['_Tier'];

                    var $isEmptyProperty = $.isEmptyObject($thisProps);
                    if ($isEmptyProperty) {
                        // if properties is empty then, remove the product and add back
                        replaceProduct($thisKey, $vID, $thisQty, isOpenDrawer);
                    } else {
                        // if properties not empty then, just update the properties
                        cartJSUpdateQuery($thisKey, $thisQty, $thisProps, isOpenDrawer);
                    }
                }
            }
        });
    });
}

replaceProduct = ($key, $vid, $qty, isOpenDrawer) => {
    CartJS.removeItemById($key,
        {
            "success": function (data, textStatus, jqXHR) {
                cartJSAddQuery($vid, $qty, {}, isOpenDrawer);
            },
            "error": function (jqXHR, textStatus, errorThrown) {
                console.log("Error occur !", errorThrown);
            }
        });
}
//End tier discount promo

//Start variant selected in pdp for bundle and pwp
variantOption = (evt, index, setValue) => {
    var $this = $(evt);
    var $thisImgUrl = $this.find(':selected').attr('data-img');
    var $thisVid = $this.val();
    var $thisPrice = $this.find(':selected').attr('data-price');
    var $thisTitle = $this.find(':selected').text();
    var $thisComparePrice = $this.find(':selected').attr('data-compare-price');
    var $isDiscounted = $this.find(':selected').attr('data-settings-discount') == 'true';
    var $currencyFormat = $('html').attr('data-currency');
    var $variantTitleEle = $this.parents('.jsc-promo-grid').find('span.jsc-variant-title');

    var $hiddenEle = $this.parents('.jsc-container').find('.jsc-hidden');
    var $discountType = $hiddenEle.val();
    var $minusPrice = $discountType == 'percentage-off' ? parseFloat($hiddenEle.attr('data-' + $discountType + '-' + index)) : parseInt($hiddenEle.attr('data-' + $discountType + '-' + index));

    // update image
    $this.parents('.jsc-promo-grid').find('img').attr('src', $thisImgUrl);

    // update price
    if ($isDiscounted) { // if discount value is not empty in theme settings, then calculate the price
        var $discountedValue = 0;
        if ($discountType == 'percentage-off') {
            $discountedValue = $thisPrice * $minusPrice;
        } else {
            $discountedValue = $thisPrice - $minusPrice;
        }

        var price = $thisComparePrice;
        var discountprice = $thisPrice;

        console.log($this.siblings('.jsc-price').find('strike'), $this.siblings('.jsc-price').find('span'));

        $this.siblings('.jsc-price').find('strike').text(price);
        $this.siblings('.jsc-price').find('span').text(discountprice);
    } else { // if discount value is empty in theme settings, then show normal price
        if ($thisComparePrice) {
            var comparePrice = $thisComparePrice;
            $this.siblings('.jsc-price').find('strike').text(comparePrice);
            $this.siblings('.jsc-price').find('strike').show();
        } else {
            $this.siblings('.jsc-price').find('strike').hide();
        }
        var price = $thisPrice;
        $this.siblings('.jsc-price').find('span').text(price);
    }

    // update variant ID
    $this.parents('.jsc-promo-grid').attr('data-vid', $thisVid);

    // This function is to hide atc btn and show limit message if pwp reached the set limit
    if (setValue) {
        pwpSetValidationPdp(setValue, $this);
    }

    if ($variantTitleEle.length > 0) {
        $variantTitleEle.html($thisTitle);
    }
}
//End variant selected in pdp for bundle and pwp

//Start PWP promo
pwpAddToCart = (evt, discount2, discountType, index) => {
    var $this = $(evt);
    var properties1 = {};
    var properties2 = {};
    var vid1 = parseInt($this.parents('.jsc-promoSection').find('.jsc-pwp-col-1').attr('data-vid'));
    var vid2 = parseInt($this.parents('.jsc-promoSection').find('.jsc-pwp-col-2').attr('data-vid'));
    var $bindId = vid1 + '-' + vid2;


    properties1['_PWP'] = 'Master';
    properties1['_BindID'] = $bindId;
    properties1['_Promo-No'] = index;


    properties2['_PWP'] = 'Child';
    properties2['_BindID'] = $bindId;
    properties2['_Promo-No'] = index;

    cartJSAddQuery(vid1, 1, properties1, true);
    cartJSAddQuery(vid2, 1, properties2, true);

    var cartType = $('#cart-type').val();
}

removePwp = (evt, bindid, pwp) => {
    setTimeout(function () {
        $.when($.getJSON('/cart.js')).then(function (cart) {
            var $items = cart.items;
            for (var i = 0; i < $items.length; i++) {
                var $thisKey = $items[i].key;
                var $thisQty = $items[i].quantity;
                var $thisProps = $items[i].properties;
                var $vID = parseInt($items[i].variant_id);

                if ($thisProps['_BindID'] == bindid) {

                    if (pwp == 'Master') {
                        // if customer remove master product we remove the child product
                        cartJSUpdateQuery($thisKey, 0, {}, true);
                    } else if (pwp == 'Child') {
                        // if customer remove child product we keep the master product, but remove the pwp properties
                        delete $thisProps['_Quantity-Promo'];
                        delete $thisProps['_Off-Value'];
                        delete $thisProps['_BindID'];
                        delete $thisProps['_PWP'];
                        delete $thisProps['_Promo-No'];

                        var $isEmptyProperty = $.isEmptyObject($thisProps);
                        if ($isEmptyProperty) {
                            // if properties is empty then, remove the product and add back
                            replaceProduct($thisKey, $vID, $thisQty, true);
                        } else {
                            // if properties not empty then, just update the properties
                            cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
                        }
                    }
                }
            }
        });
    }, 900);
    // Note: pwpSetValidationCart is already called by masterPromo in cart.requestComplete handler
}

updatePwp = (evt, bindid) => {
    setTimeout(function () {
        $.when($.getJSON('/cart.js')).then(function (cart) {
            var $items = cart.items;
            for (var i = 0; i < $items.length; i++) {
                var $thisKey = $items[i].key;
                var $thisQty = $items[i].quantity;
                var $thisProps = $items[i].properties;
                $thisQty -= 1;
                if ($thisProps['_BindID'] == bindid && $thisProps['_PWP'] == 'Child') {
                    cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
                    console.log('slow333', $thisQty);
                }
            }
        });
    }, 900);
}

pwpSetValidationPdp = (setValue, $this) => {
    var $v1 = $this.parents('.jsc-container').find('.jsc-pwp-col-1').attr('data-vid');
    var $v2 = $this.parents('.jsc-container').find('.jsc-pwp-col-2').attr('data-vid');
    var $bId = $v1 + '-' + $v2;
    var $isInCart = false;
    $.when($.getJSON('/cart.js')).then(function (cart) {
        var $items = cart.items;
        for (var i = 0; i < $items.length; i++) {
            var $thisQty = $items[i].quantity;
            var $thisProps = $items[i].properties;

            if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
                if ($thisQty >= setValue) { // if pwp variant have reached set limit
                    $this.parents('.jsc-container').find('.jsc-set-limit-msg').show();
                    $this.parents('.jsc-container').find('.jsc-atc-btn').hide();
                } else { // if pwp variant not yet reached set limit
                    $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
                    $this.parents('.jsc-container').find('.jsc-atc-btn').show();
                }
                $isInCart = true;
            }
        }

        // if variant is not in cart
        if (!$isInCart) {
            $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
            $this.parents('.jsc-container').find('.jsc-atc-btn').show();
        }
    });
}

pwpSetValidationCart = () => {
    var $pwpContainer = $('.jsc-pwp-container');

    $pwpContainer.each(function () {
        var $this = $(this);
        var $v1 = $this.parents('.jsc-promoSection').find('.jsc-pwp-col-1').attr('data-vid');
        var $v2 = $this.parents('.jsc-promoSection').find('.jsc-pwp-col-2').attr('data-vid');
        var $bId = $v1 + '-' + $v2;
        var $isInCart = false;
        var $setValue = parseInt($this.attr('data-set'));

        if ($setValue) {
            $.when($.getJSON('/cart.js')).then(function (cart) {
                var $items = cart.items;
                for (var i = 0; i < $items.length; i++) {
                    var $thisQty = $items[i].quantity;
                    var $thisProps = $items[i].properties;

                    if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
                        if ($thisQty >= $setValue) { // if pwp variant have reached set limit
                            $this.parents('.jsc-promoSection').find('.jsc-set-limit-msg').show();
                            $this.parents('.jsc-promoSection').find('.jsc-atc-btn').hide();
                        } else { // if pwp variant not yet reached set limit
                            $this.parents('.jsc-promoSection').find('.jsc-set-limit-msg').hide();
                            $this.parents('.jsc-promoSection').find('.jsc-atc-btn').show();
                        }
                        $isInCart = true;
                    }
                }
                // if variant is not in cart
                if (!$isInCart) {
                    $this.parents('.jsc-promoSection').find('.jsc-set-limit-msg').hide();
                    $this.parents('.jsc-promoSection').find('.jsc-atc-btn').show();
                }
            });
        }
    });
}
//End PWP promo
//Start bundle promo
bundleAddToCart = (evt, discount1, discount2, discountType, i) => {
    var $this = $(evt);
    var properties1 = {};
    var properties2 = {};
    var vid1 = parseInt($this.parents('.jsc-promoSection').find('.jsc-bundle-col-1').attr('data-vid'));
    var vid2 = parseInt($this.parents('.jsc-promoSection').find('.jsc-bundle-col-2').attr('data-vid'));
    var $bindId = vid1 + '-' + vid2;


    properties1['_Bundle'] = true;
    properties1['_BindID'] = $bindId;
    properties1['_Promo-no'] = i;

    properties2['_Bundle'] = true;
    properties2['_BindID'] = $bindId;
    properties2['_Promo-no'] = i;

    cartJSAddQuery(vid1, 1, properties1, true);
    cartJSAddQuery(vid2, 1, properties2, true);
}

updateTolimitbundle = () => {
    var $uptEle = $('.jsc-update-bundle-fix');
    $uptEle.each(function () {
        var $this = $(this);
        var $key = $this.val();
        var discountType = $this.attr('data-discType');
        var discount = $this.attr('data-offvalue');
        var $bindId = $this.attr('data-bindId');
        var i = $this.attr('data-promo');
        var $thisQty = $this.attr('data-qty');
        var properties = {};
        properties['_Bundle'] = true;
        properties['_BindID'] = $bindId;
        properties['_Promo-no'] = i;
        properties['_Limit-Discount'] = true;
        cartJSUpdateQuery($key, $thisQty, properties, true);
    });
}

removeBundle = (evt, bindid, key) => {
    cartJSUpdateQuery(key, 0);
    // Use one-time handler instead of adding new listener each time
    $(document).one('cart.requestComplete', function (event, cart) {
        bundleCartAjax(bindid);
    });
}

removeBundleOnThemeSettings = () => {
    var $removeEle = $('.jsc-remove-bundle');

    $removeEle.each(function () {
        var $this = $(this);
        var $bindId = $this.val();
        var $container = $('.' + $this.attr('data-container'));

        if ($container.length > 0) {
            $container.hide();
        }

        setTimeout(function () {
            bundleCartAjax($bindId);
        }, 900);
    })

}

bundleCartAjax = (bindid) => {
    $.when($.getJSON('/cart.js')).then(function (cart) {
        var $items = cart.items;
        for (var i = 0; i < $items.length; i++) {
            var $thisKey = $items[i].key;
            var $thisQty = $items[i].quantity;
            var $thisProps = $items[i].properties;
            var $vID = parseInt($items[i].variant_id);

            if ($thisProps['_BindID'] == bindid) {
                delete $thisProps['_Quantity-Promo'];
                delete $thisProps['_Off-Value'];
                delete $thisProps['_Bundle'];
                delete $thisProps['_BindID'];
                delete $thisProps['_Promo-no'];

                var $isEmptyProperty = $.isEmptyObject($thisProps);
                if ($isEmptyProperty) {
                    // if properties is empty then, remove the product and add back
                    replaceProduct($thisKey, $vID, $thisQty, true);
                } else {
                    // if properties not empty then, just update the properties
                    cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
                }
            }
        }
    });
}
//End bundle promo

//Start check history path
goHistoryPath = () => {
    console.log('path: ',window.location.pathname);
    if (window.location.pathname == '/' || window.location.pathname == '/en') {
        $('.purchase-confirmation-popup').removeClass('active');
    } else {
        history.back();
    }
}
//End check history path

//Start init date picker
initDate = () =>{
    var startDate = new Date(1900, 1 - 1, 1);
    var currentDate = new Date();
    var endDate = new Date(new Date().getFullYear() - 10, currentDate.getMonth(), currentDate.getDate());
    $('#jsc-birthday').datepicker({
        format: 'yyyy-mm-dd',
        startDate: startDate,
        endDate: endDate,
        startView: 2,
        maxViewMode: 2
    });
}
//End init date picker

// Start PDPA Function

customerAPI = (fn,ln,id,tel,birth,oTel,oBirth,prov,gen,oPro,oGen,oPdpa,nPdpa,pdpaId,pdpaIdList) =>{

    let $data = {
        id: id,
        first_name: fn,
        last_name: ln,
        telephone: `__tel:${tel}`,
        birthday: `__birthday:${birth}`,
        province: `__province:${prov}`,
        gender: `__gender:${gen}`,
        old_tel: oTel,
        old_brith: oBirth,
        old_pro: oPro,
        old_gen: oGen,
        old_pdpa: oPdpa,
        pdpa: nPdpa,
        pdpaId: `__id:${pdpaId}`,
        pdpaList: pdpaIdList
    };

    $.ajax({
      url: 'https://webhooks.mechanic.dev/a34abea8-6d17-4137-9e04-024910276673',//user/custom/customer
      method: 'POST',
      headers: {
         'content-type': 'application/json'
      },
      data: JSON.stringify($data)
    });
}

customerInitAPI = (fn,ln,id,tel,birth,prov,gen,pdpa, pdpaId,email) =>{

    let $data = {
        id: id,
        first_name: fn,
        last_name: ln,
        telephone: `__tel:${tel}`,
        birthday: `__birthday:${birth}`,
        province: `__province:${prov}`,
        gender: `__gender:${gen}`,
        pdpa: `__pdpa:${pdpa}`,
        pdpaId: `__id:${pdpaId}`,
        email: email
    };

    $.ajax({
      url: 'https://webhooks.mechanic.dev/acd449e0-58c5-4eae-be53-92923f6b0547', //user/custom/update
      method: 'POST',
      headers: {
         'content-type': 'application/json'
      },
      data: JSON.stringify($data)
    });
}

validateUpdate = ($first_name, $last_name, $telephone, $birthday) =>{
    var $isError = true;

    if ($first_name == '') {
        $('#first_name_error').show();
        $isError = false;
    } else {
        $('#first_name_error').hide();
    }

    if ($last_name == '') {
        $('#last_name_error').show();
        $isError = false;
    } else {
        $('#last_name_error').hide();
    }

    if ($telephone == '') {
        $('#telephone_error').show();
        $isError = false;
    } else {
        if ($telephone.length == 10) {
            $isError = true;
            $('#telephone_valid').hide();
        } else {
            $isError = false;
            $('#telephone_valid').show();
        }
        $('#telephone_error').hide();
    }

    if ($birthday == '') {
        $('#birthday_error').show();
        $isError = false;
    } else {
        $('#birthday_error').hide();
    }

    return $isError;
}

updatePdpa = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $this = $(evt);
    var $id = parseInt($('#jsc-customer-pdpa-id').val());
    var $idList = $('#jsc-customer-pdpa-id-list').val();
    var $shopifyId = parseInt($('#jsc-customer-id').val());
    var $first_name = $('#FirstName').val();
    var $last_name = $('#LastName').val();
    var $email = $('#Email').val();
    var $telephone = $('#jsc-register_mobile').val();
    var $birthday = $('#jsc-birthday').val();
    var $province = $('#jsc-province').val();
    var $gender = $('#jsc-gender').val();
    var $isvalidated = validateUpdate($first_name, $last_name, $telephone, $birthday);

    var $oldTel = $('#jsc-customter-old-tel').val();
    var $oldBirth = $('#jsc-customter-old-birth').val();
    var $oldProvince = $('#jsc-customter-old-province').val();
    var $oldGender = $('#jsc-customter-old-gender').val();
    var $isConsent = $('#jsc-accepts_marketing').prop('checked');
    var $oldPdpa = $isConsent ? '__pdpa:false' : '__pdpa:true';
    var $newPdpa = $isConsent ? '__pdpa:true' : '__pdpa:false';

    if($gender == 'Male'){
        $gender = 'ชาย';
    } else if($gender == 'Female'){
        $gender = 'หญิง';
    } else if($gender == 'Others'){
        $gender = 'อื่นๆ';
    }

    var $isId = isNaN($id);
    if ($isvalidated) {
        if ($isConsent || $isId) {
            var webhook = 'https://webhooks.mechanic.dev/f8607954-cbb5-4ddb-9ba8-d5bb944fbd34'; // user/update_pdpa/one
            if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
            $gender = '';
            }
        
            let $data = {
            first_name: $first_name,
            last_name: $last_name,
            birthday: $birthday,
            email: $email,
            telephone: $telephone,
            province: $province,
            gender: $gender,
            isConsent: $isConsent,
            shopify_customer_id: $shopifyId,
            old_tel: $oldTel,
            old_brith: $oldBirth,
            old_pro: $oldProvince,
            old_gen: $oldGender,
            old_pdpa: $oldPdpa,
            pdpa: $newPdpa,
            id_list: $idList
            };
            $.ajax({
            url: webhook,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: JSON.stringify($data)
            }).done(function () {
            setTimeout(function(){
                $loader.hide();
                location.reload();
            },24000);
            });
        } else {
            var webhook_2 = 'https://webhooks.mechanic.dev/e5ce53f2-ef24-45cf-ad5a-3c9e74e11cb5'; // user/update_pdpa/two
            if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
            $gender = '';
            }
        
            let $data = {
            id: $id,
            first_name: $first_name,
            last_name: $last_name,
            birthday: $birthday,
            email: $email,
            telephone: $telephone,
            province: $province,
            gender: $gender,
            isConsent: $isConsent,
            shopify_customer_id: $shopifyId,
            old_tel: $oldTel,
            old_brith: $oldBirth,
            old_pro: $oldProvince,
            old_gen: $oldGender,
            old_pdpa: $oldPdpa,
            pdpa: $newPdpa,
            id_list: $idList
            };
            $.ajax({
            url: webhook_2,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: JSON.stringify($data)
            }).done(function () {
            setTimeout(function(){
                $loader.hide();
                location.reload();
            },24000);
            });
        }
    } else {
    $loader.hide();
    }
}

checkSubscriptionMarketing = (evt) =>{
    var $this = $(evt);
    var $isConsent = $this.prop('checked');
    var $submitButton = $('#subscription-submit');

    console.log('checkSubscriptionMarketing - $isConsent: ', $isConsent);

    if ($isConsent) {
        $submitButton.removeClass('disabled-submit');
    } else {
        $submitButton.addClass('disabled-submit');
    }
}

submitSubscriptionPdpa = (evt) =>{
    // var $loader = $('.jsc-loader-overlay');
    // $loader.show();
    var $this = $(evt);
    var $id = parseInt($('#jsc-customer-pdpa-id').val());
    var $idList = $('#jsc-customer-pdpa-id-list').val();
    var $shopifyId = parseInt($('#jsc-customer-id').val()) || "";
    var $first_name = $('#FirstName').val();
    var $last_name = $('#LastName').val();
    var $email = $('#Email').val();
    var $telephone = $('#jsc-register_mobile').val();
    var $birthday = $('#jsc-birthday').val();
    var $province = $('#jsc-province').val();
    var $gender = $('#jsc-gender').val();
    var $isvalidated = validateUpdate($first_name, $last_name, $telephone, $birthday);

    var $oldTel = $('#jsc-customter-old-tel').val();
    var $oldBirth = $('#jsc-customter-old-birth').val();
    var $oldProvince = $('#jsc-customter-old-province').val();
    var $oldGender = $('#jsc-customter-old-gender').val();
    var $isConsent = $('#jsc-accepts_marketing').prop('checked');
    var $oldPdpa = $isConsent ? '__pdpa:false' : '__pdpa:true';
    var $newPdpa = $isConsent ? '__pdpa:true' : '__pdpa:false';

    var $subscriptionTag = $('#jsc-subscription-tag').val();

    if($gender == 'Male'){
        $gender = 'ชาย';
    } else if($gender == 'Female'){
        $gender = 'หญิง';
    } else if($gender == 'Others'){
        $gender = 'อื่นๆ';
    }

    console.log('submitSubscriptionPdpa - shopifyId: ', $shopifyId);

    var emailDOM = $('#Email')[0];
    // console.log('emailDOM.checkValidity(): ', emailDOM.checkValidity());
    if ($email == '') {
      $isvalidated = false;
      $('#email_error').show();
    } else {
      $('#email_error').hide();
      if (!emailDOM.checkValidity()) {
        $isvalidated = false;
        $('#email_invalid_error').show();
      } else {
        $('#email_invalid_error').hide();
      }
    }

    var $isId = isNaN($id);
    if ($isvalidated) {
        // Show thank you modal instead of loader
        let mechanicWebhook = '';
        if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
            $gender = '';
        }
        let $data = {
            first_name: $first_name,
            last_name: $last_name,
            birthday: $birthday,
            email: $email,
            telephone: $telephone,
            province: $province,
            gender: $gender,
            isConsent: $isConsent,
            shopify_customer_id: $shopifyId,
            old_tel: $oldTel,
            old_brith: $oldBirth,
            old_pro: $oldProvince,
            old_gen: $oldGender,
            old_pdpa: $oldPdpa,
            pdpa: $newPdpa,
            id_list: $idList,
            subscription_tag: $subscriptionTag
        };
        if ($shopifyId == '') {
            mechanicWebhook = 'https://webhooks.mechanic.dev/425a73d3-d5c5-4bcb-ba3f-e6550cbd99f2';// user/subscription_form/submit
        } else if ($isConsent || $isId) {
            mechanicWebhook = 'https://webhooks.mechanic.dev/f8607954-cbb5-4ddb-9ba8-d5bb944fbd34'; // user/update_pdpa/one
        } else {
            mechanicWebhook = 'https://webhooks.mechanic.dev/e5ce53f2-ef24-45cf-ad5a-3c9e74e11cb5'; // user/update_pdpa/two
            $data.id = $id;
        }

        console.log('submitSubscriptionPdpa - mechanicWebhook: ', mechanicWebhook);
        console.log('submitSubscriptionPdpa - $data: ', $data);
        $.ajax({
            url: mechanicWebhook,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: JSON.stringify($data)
        })
        .done(function () {
            // Show close button when AJAX is done
            console.log('submitSubscriptionPdpa: ', $('#jsc-subscription-form__container'));
            if ($('#jsc-thank-you__container').length) {
                $('#jsc-thank-you__container').css('display', 'block');
                $('#jsc-subscription-form__container').css('display', 'none');
            }
        });
    } else {
        // Hide modal if validation fails
        console.log('submitSubscriptionPdpa validation failed: ', $('#jsc-subscription-form__container'));
        if ($('#jsc-thank-you__container').length) {
            $('#jsc-thank-you__container').css('display', 'none');
            $('#jsc-subscription-form__container').css('display', 'flex');
        }
    }
}

validateRegister = ($first_name, $last_name, $email, $telephone, $birthday, $password) =>{
    var $isError = true;

    if ($first_name == '') {
        $('#first_name_error').show();
        $isError = false;
    } else {
        $('#first_name_error').hide();
    }

    if ($last_name == '') {
        $('#last_name_error').show();
        $isError = false;
    } else {
        $('#last_name_error').hide();
    }

    if ($email == '') {
        $('#email_error').show();
        $isError = false;
    } else {
        $('#email_error').hide();
    }

    if ($telephone == '') {
        $('#telephone_error').show();
        $isError = false;
    } else {
        $('#telephone_error').hide();
        if ($telephone.length != 10) {
            $('#telephone_valid').show();
            $isError = false;
        } else {
            if ($telephone.slice(0,1) != '0') {
                $('#telephone_valid').show();
                $isError = false;
            } else {
                $('#telephone_valid').hide();
            }
        }
    }

    if ($birthday == '') {
        $('#birthday_error').show();
        $isError = false;
    } else {
        $('#birthday_error').hide();
    }

    if ($password == '') {
        $('#password_error').show();
        $isError = false;
    } else {
        $('#password_error').hide();
    }

    return $isError;
}

pdpaConsent = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $this = $(evt);
    var $form = $('#RegisterForm');
    var $first_name = $form.find('input[name="customer[first_name]"]').val();
    var $last_name = $form.find('input[name="customer[last_name]"]').val();
    var $email = $form.find('input[name="customer[email]"]').val();
    var $telephone = $form.find('input[name="telephone"]').val();
    var $birthday = $form.find('input[name="birthday"]').val();
    var $isConsent = $form.find('#jsc-accepts_marketing').prop('checked');
    var $password = $form.find('input[name="customer[password]"]').val();
    var $isvalidated = validateRegister($first_name, $last_name, $email, $telephone, $birthday, $password);
    var $errorMsg = $this.siblings('.jsc-form-status__message.form-status__message--error');

    setTimeout(function(){
        if ($isvalidated) {
            $('#jsc-customer-tag').val('__tel:'+$telephone+',__birthday:'+$birthday+',__pdpa:'+$isConsent);
            var $customerTags = `__tel:${$telephone},__birthday:${$birthday},__pdpa:${$isConsent}`;
            $errorMsg.empty();
            register($email, $password, $first_name, $last_name, $customerTags, $isConsent).done(function(html){
                var emailError = $(html).find('a[href="#RegisterForm-email"]')[0];
                var passwordError = $(html).find('a[href="#RegisterForm-password"]')[0];

                var emailErrorFormated = $(emailError).text().trim().replace(/\s+/g, ' ');
                var passwordErrorFormated = $(passwordError).text().trim().replace(/\s+/g, ' ')
                // console.log('emailError: ', emailErrorFormated);
                // console.log('passwordError: ', passwordErrorFormated);
                var hasError = false;
                if (emailErrorFormated == 'อีเมล ไม่ถูกต้อง' || emailErrorFormated == 'Email is invalid') {
                    // console.log('Invalid email or pasword');
                    var errorItem = $('<li></li>').text('อีเมล ไม่ถูกต้อง');
                    $errorMsg.append(errorItem);
                    $errorMsg.removeClass('d-none');
                    hasError = true;
                }
                if (passwordErrorFormated == 'รหัสผ่าน สั้นเกินไป (ต่ำสุดคือ 5 ตัวอักษร)' || passwordErrorFormated == 'Password is too short (minimum is 5 characters)'){
                    // console.log('Password is too short (minimum is 5 characters)');
                    var errorItem = $('<li></li>').text('รหัสผ่าน สั้นเกินไป (ต่ำสุดคือ 5 ตัวอักษร)');
                    $errorMsg.append(errorItem);
                    $errorMsg.removeClass('d-none');
                    hasError = true;
                }
                if (!hasError){
                    $errorMsg.addClass('d-none');
                    // console.log('success register');
                    document.location.href = '/account/login';
                }
            });
        }
        $loader.hide();
    },1800);
}

enableAccountUpdateWhenFoundChanges = () =>{
    // Get the input elements
    var accountPagePdpaInputs = $("#FirstName, #LastName, #jsc-register_mobile, #jsc-birthday, #jsc-province, #jsc-gender, #jsc-accepts_marketing");

    // Get the submit button
    var updatePdpaButton = $("#register-submit");

    // Store the initial values
    var initialValues = {};
    accountPagePdpaInputs.each(function () {
      if ($(this).is(":checkbox")) {
        initialValues[this.id] = $(this).prop("checked");
      } else {
        initialValues[this.id] = $(this).val();
      }
    });

    // Add event listener to all input fields
    accountPagePdpaInputs.on("input change", function () {
      var allValuesMatch = accountPagePdpaInputs.toArray().every(function (input) {
        if ($(input).is(":checkbox")) {
          // For checkboxes, check the "checked" property
          return $(input).prop("checked") === initialValues[input.id];
        } else {
          // For other input types, check the "value" property
          return $(input).val() === initialValues[input.id];
        }
      });

      // Enable or disable the submit button based on whether any values have changed
      updatePdpaButton.prop("disabled", allValuesMatch);
    });
}
// End PDPA Function

// Start The 1 & Tax Invoice
formatString = (n) =>{
    var chars = n.substring(0,3);
    var xChar = n.substr(3).replace(/\D/g,'x');

    var newLastName = chars + xChar;

    return newLastName;
}
oneCardRemove = (e,cusId) => {
    var $this = $(e);
    var $loader = $('.jsc-loader-overlay');
    $loader.show();

    // Run Mechanic webhook
    let $data = {
      customerId: cusId
    };
    $.ajax({
      url: 'https://webhooks.mechanic.dev/6e61e765-57e7-4da8-8843-b8cff5b7ccf0',
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify($data)
    }).done(function () {
      $('#jsc-id-num').val('');
      $loader.hide();
      $this.hide();
      $('#jsc-one-card-success').show();
    });
}
const parseTagsFromLiveCustomerDocument = (doc) => {
    const el = doc.getElementById('LiveCustomerData');
    if (!el) return null;

    try {
      const data = JSON.parse(el.textContent.trim());
      return Array.isArray(data.tags) ? data.tags : [];
    } catch (error) {
      return null;
    }
};

const fetchLiveCustomerTags = async () => {
    try {
      const response = await fetch(window.location.pathname, { credentials: 'same-origin' });
      if (!response.ok) return null;
      const html = await response.text();
      if (!html.trim()) return null;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return parseTagsFromLiveCustomerDocument(doc);
    } catch (error) {
      console.error('Failed to fetch live customer tags:', error);
      return null;
    }
};
const pollForOneCardTag = ($loader, $oneCardNo = '', intervalMs = 1500, timeoutMs = 20000) => {
    const start = Date.now();

    const interval = setInterval(async () => {
      const tags = await fetchLiveCustomerTags();
      console.log('pollForOneCardTag - tags',tags);

      if (tags === null) return;

      const isDone = tags.some((tag) => tag === `${$oneCardNo}_one_card_success` || tag.startsWith(`${$oneCardNo}_one_card_error_`));

      if (!isDone && Date.now() - start < timeoutMs) return;

      clearInterval(interval);
      setTimeout(function(){
        $loader.hide();
        location.reload();
      }, 1000);
    }, intervalMs);
};
oneCardVerfication = (e, dT, cusId) =>{
    var $this = $(e);
    var $loader = $('.jsc-loader-overlay');
    var $oneCardNoEle = $('#jsc-id-num');
    var $oneCardNo = $oneCardNoEle.val();

    $loader.show();

    if ($oneCardNo != '') {
        $('#jsc-one-card-error').hide();
        let _data = {
          sourceTransID: `CMG_${cusId}_${dT}`,
          requestTime: dT,
          cardNo: $oneCardNo,
          customerId: cusId
        };
        $.ajax({
          url: 'https://webhooks.mechanic.dev/6d2f0053-07e0-4e6a-ae6f-9bd245bc90e0', // user/migrate/onecard
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          data: JSON.stringify(_data)
        }).done(function () {
            setTimeout(function(){
                pollForOneCardTag($loader, $oneCardNo);
            },8000);
        });
      } else {
        $('#jsc-one-card-error').show();
        $('#jsc-one-card-ajax-error').hide();
        $('#jsc-one-card-success').hide();
        $loader.hide();
      }
}

removeOneCardError = () =>{
    var isTriggerRemoveTag = $('#trigger-remove-error').length;

    if (isTriggerRemoveTag) {
        var tag_val = $('#trigger-remove-error').val();
        var customer_id = $('#trigger-remove-error').attr('data-id');
        let _data = {
        tag: tag_val,
        customer_id: customer_id
        };
        $.ajax({
        url: 'https://webhooks.mechanic.dev/f2a517ca-14da-46c9-ae1d-b8b4be1f4863', // user/migrate/onecard_remove_error
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify(_data)
        }).done(function () {
        
        });
    }
}

onChangeSelection = (e, key) => {
    var $this = $(e);
    var $val = $this.val();
    $.getJSON('/cart.js', function(cart) {
        var getCartAttribute = cart.attributes;
        var cartAttr = getCartAttribute[key];

        if (cartAttr != $val) {
            getCartAttribute[key] = $val;
            if ($val == 'Headquarter') {
                getCartAttribute['branch_id'] = '00000';
            } else {
                getCartAttribute['branch_id'] = '';
            }
            CartJS.setAttributes(getCartAttribute);
        }
    });
}
isInvoice = (e) =>{
    var $this = $(e);
    var $val = $this.val();
    var $html = `<p class="cart-attribute__field jsc-personal-company m-t-15">
      <label class="fontWeight-6 line-height-2 fontSize-s m-b-5 ">คุณต้องการขอใบกำกับภาษีในนามบุคคลหรือนิติบุคคล</label>
      <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-personal-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Personal"> <label class="vertical-middle fontWeight-6 cursor p-r-25 inline m-b-0 fontSize-s" for="jsc-personal-radio">ส่วนบุคคล</label>
      <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-company-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Company"> <label class="vertical-middle fontWeight-6 cursor inline m-b-0 fontSize-s" for="jsc-company-radio">ในนามบริษัท</label><br>
    </p>`;

    if ($val == 'Yes') {
      $('.jsc-tax-invoice-inputs').append($html);
    } else {
      if ($('.jsc-personal-company').length) {
        $('.jsc-personal-company').remove();
      }
      if ($('.jsc-personal').length) {
        $('.jsc-personal').remove();
      }
      if ($('.jsc-company').length) {
        $('.jsc-company').remove();
      }
    }

    onChangeSelection(e, 'isFullTax');
}
isPersonalOrCompany = (e) =>{
    var $this = $(e);
    var $val = $this.val();

    if ($val == 'Personal') {
      var $html = `<div class="jsc-personal jsc-inputs-details m-t-15">
        <p class="fontWeight-6 line-height-2 m-b-0 fontSize-s">ส่วนบุคคล</p>
        <p class="cart-attribute__field relative m-b-20">
          <label class="fontSize-s m-b-5" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
          <input  class="fontSize-s input" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="" oninput="saveAttrOnChange(this,'vat_id',true)">
        </p>
        <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
        <span class="btn btn--primary fontSize-s" onclick="saveCartAttr(this)"><span>บันทึกเพื่ออัปเดต</span></span>
      </div>`;
      $('.jsc-tax-invoice-inputs').append($html);
      if ($('.jsc-company').length) {
        $('.jsc-company').remove();
      }
    } else {
      var $html = `<div class="jsc-company jsc-inputs-details m-t-15">
        <p class="fontWeight-6 line-height-2 m-b-0 fontSize-s">ในนามบริษัท</p>
        <p class="cart-attribute__field relative m-b-30">
          <label class="fontSize-s m-b-5" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
          <input required class="required fontSize-s input" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="" placeholder="เลขประจำตัวผู้เสียภาษี" oninput="saveAttrOnChange(this,'vat_id',false)">
        </p>
        <p class="cart-attribute__field relative m-b-30">
          <label class="fontSize-s m-b-5" for="company-name">ชื่อบริษัท<span style="color: red;"> *</span></label>
          <input required class="required fontSize-s input" id="company-name" type="text" name="attributes[company]" value="" placeholder="ชื่อบริษัท" oninput="saveAttrOnChange(this,'company',false)">
        </p>
        <p class="cart-attribute__field relative m-b-30">
          <label class="fontSize-s m-b-5" for="branch-type">ประเภทของสำนักงาน<span style="color: red;"> *</span></label>
          <select onchange="onChangeBType(this)" required class="required fontSize-s input" id="branch-type" name="attributes[Branch Type]">
            <option value="Headquarter">สำนักงานใหญ่</option>
            <option value="Branch">สาขา</option>
          </select>
        </p>
        <p class="cart-attribute__field m-b-0">
          <label class="fontSize-s m-b-5" for="branch-id">รหัสสาขา<span style="color: red;"> *</span></label>
          <div class="relative">
            <input required class="required fontSize-s full-width input m-b-0" id="branch-id" type="text" maxlength="5" name="attributes[branch_id]" value="00000" placeholder="รหัสสาขา" oninput="saveAttrOnChange(this,'branch_id',false)">
            <span id="jsc-b-id-overlay"></span>
          </div>
        </p>
        <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
        <span class="btn btn--primary fontSize-s" onclick="saveCartAttr(this)"><span>บันทึกเพื่ออัปเดต</span></span>
      </div>`;
      $('.jsc-tax-invoice-inputs').append($html);
      if ($('.jsc-personal').length) {
        $('.jsc-personal').remove();
      }
    }

    onChangeSelection(e, 'Are you a Personal or Company (Individual Company)');
}
saveCartAttr = (e) =>{
    var $this = $(e);
    var $inputs = $this.parents('.jsc-inputs-details').find('input');
    var isFilled = true;

    $inputs.each(function(){
      var $_this = $(this);
      var $_val = $_this.val();
      console.log('dddd',$_val);

      if (!$_val) {
        isFilled = false;
      }
    });

    if (isFilled) {
      $('#jsc-required-text').hide();
      $this.html('<span>บันทึกเสร็จแล้ว!</span>');
      cartJSSaveAttr();
    } else {
      $('#jsc-required-text').show();
      $this.html('<span>บันทึกเพื่ออัปเดต</span>');
    }
}
cartJSSaveAttr = () =>{
    var input_elements = $('.jsc-tax-invoice').find('input');
    var dataObject = {};
    var isPersonal = false;

    input_elements.each(function() {
      var inputType = $(this).attr('type');
      var inputName = $(this).attr('name');
      var inputValue;

      if (inputType === 'text') {
        // For text inputs, capture the value directly
        inputValue = $(this).val();
      } else if (inputType === 'radio' && $(this).is(':checked')) {
        // For radio inputs, capture the value only if it's checked
        inputValue = $(this).val();
        if ($(this).val() == 'Personal') {
          isPersonal = true;
        }
      }

      // Extract the value inside the square brackets
      var matches = inputName.match(/\[([^\]]+)\]/);
      var key = matches ? matches[1] : null;

      if (isPersonal) {
        dataObject['company'] = 'N/A';
        dataObject['branch_id'] = 'N/A';
      }

      // Add the data to the object if name and value are defined
      if (inputName && inputValue !== undefined) {
        dataObject[key] = inputValue;
      }
    });

    // set attribute
    CartJS.setAttributes(dataObject);
}
getTaxAttr = () =>{
    $.getJSON('/cart.js', function(cart) {
      var cart_attr_obj = cart.attributes;
      console.log('ujuj',cart_attr_obj);
      if (cart_attr_obj.isFullTax) {
        $(`#jsc-${cart_attr_obj.isFullTax.toLowerCase()}-radio`).click();
      }
      if (cart_attr_obj['Are you a Personal or Company (Individual Company)']) {
        $(`#jsc-${cart_attr_obj['Are you a Personal or Company (Individual Company)'].toLowerCase()}-radio`).click();
      }
      if ($('#tax-id').length != 0) {
        $('#tax-id').val(cart_attr_obj.vat_id);
      }
      if ($('#company-name').length != 0) {
        $('#company-name').val(cart_attr_obj.company);
      }
      if ($('#branch-id').length != 0) {
        $('#branch-id').val(cart_attr_obj.branch_id);
      }
      if ($('#branch-type').length != 0) {
        $('#branch-type').val(cart_attr_obj['Branch Type']);
        if (cart_attr_obj['Branch Type'] != 'Headquarter') {
            $('#jsc-b-id-overlay').hide();
        }
      }
    });
}
onChangeBType = (e) => {
    var $this = $(e);
    var $val = $this.val();

    if ($val == 'Headquarter') {
      $('#jsc-b-id-overlay').show();
      $('#branch-id').val('00000');
    } else {
      $('#jsc-b-id-overlay').hide();
      $('#branch-id').val('');
    }
    onChangeSelection(e, 'Branch Type');
}
var typingTimer;
var doneTypingInterval = 5000;
saveAttrOnChange = (e, key, isPersonal) =>{
  clearTimeout(typingTimer);
  typingTimer = setTimeout(function() {
    $.getJSON('/cart.js', function(cart) {
      // We can access cart info
      var getCartAttribute = cart.attributes;
      getCartAttribute[key] = $(e).val();

      if (isPersonal) {
        getCartAttribute['company'] = 'N/A';
        getCartAttribute['branch_id'] = 'N/A';
        getCartAttribute['Branch Type'] = 'N/A';
      }

      CartJS.setAttributes(getCartAttribute);
    });
  }, doneTypingInterval);
}
// End The 1 & Tax Invoice
// Start live chat
openChat = (e) => {
    var $this = $(e);
    $('#lisa-open-button').click();
}

openChatFromPageFly = () =>{
    $('.jsc-open-chat').click(function(){
      $('#lisa-open-button').click();
    });
}
// End live chat

// Start: Register / Login drawer
getQueryParam = (param) => {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}
openRegisterLoginDrawer = () => {
    console.log('openRegisterLoginDrawer')
    $('#jsc-login-register-drawer').addClass('open');
    $('.login-register__overlay').css({
        'display': 'block',
        'opacity': '1'
    });
    var $clonedElement = $('.announcement-bar').clone();
    $('#announcement-content').append($clonedElement);
    $('#announcement-content .swiper').removeClass('d-none');
    $('#announcement-content .swiper').addClass('mySwiper');
    initMySwiper();
    $('.announcement-bar').not('#announcement-content .announcement-bar').addClass('d-none');
}
closeRegisterLoginDrawer = () => {
    $('#jsc-login-register-drawer').removeClass('open');
    $('.login-register__overlay').css({
        'display': 'none',
        'opacity': '0'
    });
    $('.announcement-bar').not('#announcement-content .announcement-bar').removeClass('d-none');
}
openRegisterDrawer = () => {
    $('a[data-tab="login-drawer"]').removeClass('active');
    $('a[data-tab="register-drawer"]').addClass('active');
    $('#login-drawer').removeClass('active');
    $('#register-drawer').addClass('active');
    $('#recover-password-drawer').removeClass('active');
}
openLoginDrawer = () => {
    $('a[data-tab="login-drawer"]').addClass('active');
    $('a[data-tab="register-drawer"]').removeClass('active');
    $('#login-drawer').addClass('active');
    $('#register-drawer').removeClass('active');
    $('#recover-password-drawer').removeClass('active');
}
openRecoverPasswordDrawer = () => {
    $('a[data-tab="login-drawer"]').removeClass('active');
    $('a[data-tab="register-drawer"]').removeClass('active');
    $('#login-drawer').removeClass('active');
    $('#register-drawer').removeClass('active');
    $('#recover-password-drawer').addClass('active');
}
// End: Register / Login drawer

// Start: Login form
$('form#customer_login').on('keydown', 'input', function(event) {
    if (event.key === 'Enter') {
        event.preventDefault();
    }
});
credentialChecking = (e) => {
    var _this = $(e);
    var $form = $('#customer_login');
    var $email = $form.find('input[name="customer[email]"]').val();
    var $password = $form.find('input[name="customer[password]"]').val();
    var $errorMsg = _this.siblings('.jsc-form-status__message.form-status__message--error');
    // console.log('email: ', $email);
    // console.log('password: ', $password);
    $errorMsg.empty();
    login($email, $password).done(function (html) {
        if (html.indexOf('อีเมลหรือรหัสผ่านไม่ถูกต้อง') !== -1 || html.indexOf('Incorrect email or password.') !== -1) {
        //   console.log('Incorrect email or password.');
          var errorItem = $('<li></li>').text('อีเมลหรือรหัสผ่านไม่ถูกต้อง');
          $errorMsg.append(errorItem);
          $errorMsg.removeClass('d-none');
        } else {
        //   console.log('login successful');
          $errorMsg.addClass('d-none');
          document.location.href = '/account';
        }
    });
}

login = (email, password) => {
    var data = {
      'customer[email]': email,
      'customer[password]': password,
      form_type: 'customer_login',
      utf8: '✓'
    };

    var promise = $.ajax({
      url: '/account/login',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true
    });

    // console.log('promise: ', promise);
    return promise;
}
// End: Login form
// Start: Register form
register = (email, password, firstName, lastName, customerTags, accepts_marketing) => {
    var data = {
      'customer[email]': email,
      'customer[password]': password,
      'customer[first_name]': firstName,
      'customer[last_name]': lastName,
      'customer[tags]': customerTags,
      'customer[accepts_marketing]': accepts_marketing,
      form_type: 'create_customer',
      utf8: '✓'
    };

    // console.log('email:', email);
    // console.log('password:', password);
    // console.log('firstName:', firstName);
    // console.log('lastName:', lastName);
    // console.log('email:', customerTags);

    var promise = $.ajax({
      url: '/account',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true
    });

    // console.log('register promise: ', promise);
    return promise;
}
// End: Register form
// Start: Recover password
recoverEmailChecking = (e) => {
    var _this = $(e);
    var $form = $('#recover_customer_password');
    var $email = $form.find('input[name="email"]').val();
    var $errorMsg = _this.siblings('.jsc-form-status__message.form-status__message--error');
    var $successMsg = _this.siblings('.jsc-form-status__message.form-status__message--success');

    // console.log('email: ', $email);
    $errorMsg.addClass('d-none');
    $successMsg.addClass('d-none');
    $errorMsg.empty();

    recoverPassword($email).done(function (html) {
        if (html.indexOf('ไม่พบบัญชีผู้ใช้จากอีเมลนั้น') !== -1 || html.indexOf('No account found with that email') !== -1) {
        //   console.log('No account found with that email.');
          var errorItem = $('<li></li>').text('ไม่พบบัญชีผู้ใช้จากอีเมลนั้น');
          $errorMsg.append(errorItem);
          $errorMsg.removeClass('d-none');
        } else {
        //   console.log('login successful');
          $errorMsg.addClass('d-none');
          $successMsg.removeClass('d-none');
        }
    });
}
recoverPassword = (email) => {
    var data = {
      'email': email,
      form_type: 'recover_customer_password',
      utf8: '✓'
    };

    var promise = $.ajax({
      url: '/account/recover',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true
    });

    // console.log('/account/recover promise: ', promise);
    return promise;
}
// End: Recover password
// Start: language switcher
handleCrossBorderSwitcherChoice = (e, event) => {
    event.preventDefault();
    var _this = $(e);
    var lang = _this.data('value');
    var _input = _this.siblings('input[name="locale_code"]');
    var _form = _this.parent().parent('form');
    _input.val(lang);
    _form.submit();
}
// End: language switcher